import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { H5, P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { ExerciseImage } from '../ExerciseImage';
import { Spacing } from 'styleguide/spacing';
import { LinkableText } from 'components/LinkableText';
import { colors } from 'styleguide/colors';
import { FlexRow } from 'styleguide/Row';
import { MicroIcon } from 'styleguide/Icons';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

interface ExerciseCardProps {
  title: string;
  image?: string;
  notes?: string;
  sets?: string;
  reps?: string;
  timer?: string;
  style?: CSSProperties;
  supersetColor?: string;
}

export const ExerciseCard = ({
  title,
  image,
  notes,
  sets,
  reps,
  timer,
  style,
  supersetColor,
}: ExerciseCardProps) => {
  return (
    <Container style={{ ...style }}>
      <View
        style={{
          flexDirection: 'row',
          gap: Spacing.md,
          padding: `${Spacing.md}px ${Spacing.sm}px`,
          borderLeft: `3px solid ${supersetColor}`,
        }}
      >
        <ExerciseImage diameter={64} source={image} />
        <View style={{ justifyContent: 'center', gap: Spacing.xs, flex: 1 }}>
          <H5>{title}</H5>
          <FlexRow style={{ gap: Spacing.sm }}>
            <P2>
              {sets && <>{sets}</>}
              {reps && <>{` · ${reps}`}</>}
            </P2>
            {timer && (
              <FlexRow style={{ gap: Spacing.xs }}>
                {/** This is a hack to get the icon to be the same size as the sets and reps text */}
                {
                  //!! TODO: Remove this hack when the icon is updated to be the same size as the sets and reps text
                }
                <MicroIcon type="timer" />
                <P2>{timer}</P2>
              </FlexRow>
            )}
          </FlexRow>
          <LinkableText
            text={notes}
            enableLinks
            textStyle={{
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              color: colors.grey,
            }}
          />
        </View>
      </View>
    </Container>
  );
};
